<template>
    <div class="login-page">
        <div class="login-card">
            <h2>Auditor Login</h2>
            <form @submit.prevent="handleLogin">
                <div class="form-group">
                    <label for="username">Username:</label>
                    <input 
                        type="text"
                        id="username"
                        v-model="username"
                        placeholder="Enter Auditor Account"
                        required
                    />
                </div>
                <div class="form-group">
                    <label for="password">Password:</label>
                    <input 
                        type="password"
                        id="password"
                        v-model="password"
                        placeholder="Enter Password"
                        required
                    />
                </div>
                <button type="submit" class="login-btn">Login</button>
            </form>
            <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name:'LoginPage',
    data() {
      return {
        username: '',
        password: '',
        errorMessage: ''
      };
    },
    methods: {
      handleLogin() {
        const FIXED_USERNAME='admin';
        const FIXED_PASSWORD='admin123'
        // Simple frontend validation (production should use backend API validation)
        if (this.username === FIXED_USERNAME && this.password === FIXED_PASSWORD) {
            localStorage.setItem('isLoggedIn','true');
            // Redirect to the publish page (/admin)
            this.$router.push('/admin');
        } else {
            this.errorMessage='Incorrect username or password';
        }
      }
    }
  };
  </script>
  
  <style scoped>
.login-page {
  background-color: #080915;
  color: #f1f2f6;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Inter', sans-serif;
}
.login-card {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  padding: 3rem;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.5);
  text-align: left;
}
.login-card h2 {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-align: center;
  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.form-group {
  margin-bottom: 1.5rem;
}
.form-group label {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  color: rgba(255, 255, 255, 0.8);
}
input[type="text"],
input[type="password"] {
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 0.8rem 1rem;
  color: #fff;
  font-size: 1rem;
  outline: none;
  box-sizing: border-box;
  transition: all 0.3s ease;
}
input:focus {
  border-color: #00f2fe;
  box-shadow: 0 0 10px rgba(0, 242, 254, 0.15);
  background: rgba(255, 255, 255, 0.08);
}
.login-btn {
  width: 100%;
  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
  border: none;
  color: #05060d;
  padding: 0.9rem;
  font-size: 1.1rem;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 242, 254, 0.3);
}
.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 242, 254, 0.5);
  filter: brightness(1.1);
}
.error-message {
  color: #ff4d4f;
  font-size: 0.9rem;
  margin-top: 1rem;
  text-align: center;
}
</style>